module.exports = __webpack_public_path__ + "media/13.04ca8244.mp3";